import { render, staticRenderFns } from "./modal-cv-4-portfolio.vue?vue&type=template&id=5c6935d2&lang=html&"
import script from "./modal-cv-4-portfolio.vue?vue&type=script&lang=js&"
export * from "./modal-cv-4-portfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports